let csrfToken;
let tokenHeaderName =  "x-csrf-token";
let tokenParamName = "_csrf";

const getTokenParamName = function () {
    return tokenParamName;
}

const setTokenParamName = function (name) {
    if (name) {
        tokenParamName = name;
    }
}

const getTokenHeaderName = function () {
    return tokenHeaderName;
}

const setTokenHeaderName = function (name) {
    if (name) {
        tokenHeaderName = name;
    }
}

const getToken = function () {
    return csrfToken;
}

const setToken = function (token) {
    csrfToken = token;
}

const setTokenHeaders = function (request) {
    if (csrfToken) {
        const headers = request.headers;
        headers['x-xsrf-token'] = csrfToken;
        headers['x-csrf-token'] = csrfToken;
    }
}

const getTokenFromResponse = function (response) {
    let headers = response.headers;
    let xCSRFToken = headers['x-csrf-token'];
    if (xCSRFToken) {
        csrfToken = xCSRFToken;
        return;
    }

    let xXSRFToken = headers['x-xsrf-token'];
    if (xXSRFToken) {
        csrfToken = xXSRFToken;

    }
}


export default {
    getTokenHeaderName,
    setTokenHeaderName,

    getTokenParamName,
    setTokenParamName,

    getTokenFromResponse,
    setTokenHeaders,

    getToken,
    setToken
}
